import {postService, React, useEffect} from '@api'
// import { secondaryServiceEndpoint } from '@config'
import {useStores} from '@design-board'
import {authStore} from '@utils'
import {runInAction} from 'mobx'
import {useRef} from 'react'

type MyProps = React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> & { lazy?: boolean, addAuthHeader?: boolean }

// function fetchWithAuthentication(url, authToken) {
//   const headers = new Headers()
  // headers.set('Authorization', Base64.encodeURI(authStore.securityTokenURL))
  // headers.set('Access-Control-Request-Headers', 'Authorization')
  // headers.set('X-SecurityTokenURL', Base64.encodeURI(authStore.securityTokenURL))
  //headers.set('Content-Type', 'application/json')
//   return fetch(url, {
//     // headers,
//     method: 'GET'
//   })
// }

// async function reloadImage(src, ref) {
//   // setTimeout(async() => {
//     const {site: {onError}, catalog: {stores: {config: {config: {secondaryServiceEndpoint}}}}} = useStores()
//     try{
//     // const r = await fetchWithAuthentication(src, authStore.accessToken),
//       const url = `${secondaryServiceEndpoint}/image-proxy/getImage${src.substring(src.indexOf('image-service/iiif/2') + 20, src.indexOf('/default.png'))}`
//       const r = await postService(url, 'GET', null),
//         blob = await r.blob(),
//         objectUrl = URL.createObjectURL(blob)

      
// console.log(objectUrl)
//       // Update the source of the image.
//       ref.current.src = objectUrl
//     } catch (err) {
//       onError(err)
//     }
//   // })
// }


/**
 * Wrap img to add loading='lazy' until react.d.ts is updated correctly
 * @param props
 * @constructor
 */
export const LazyImage: React.FC<MyProps> = React.forwardRef<HTMLImageElement, MyProps>(({lazy, addAuthHeader, src, onError, ...props}, ref) => {
  return <img
    // @ts-ignore
    loading={lazy ? 'lazy' : undefined}
    decoding='async'
    ref={ref}
    onError={(e) => onError(e)}
    src={src} //addAuthHeader === false ? src : null}
    // crossOrigin='anonymous'
    {...props}
  />
})

LazyImage.defaultProps = {
  lazy: true
}



// WEBPACK FOOTER //
// ./src/shared/components/ui/widgets/LazyImage.tsx